import { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { IconX } from '@tabler/icons-react';
import Cookies from 'js-cookie';
import useTheme from 'chat-ui/src/hooks/useTheme';
import useTranslation from '@/hooks/useTranslation';
import Routes from '@/router/routes';
import { ECompanyThemeName } from '@/enums';
import useOrganization from '@/hooks/useOrganization';

function FreemiumTooltip() {
  const { lang } = useTranslation();
  const { organization_id } = useParams();
  const [showTooltip, setShowTooltip] = useState<boolean | null>(null);
  const { themeName } = useTheme();

  const { organization, isLoading } = useOrganization();
  const isSubscribed = organization?.subscription?.subscribed;
  useEffect(() => {
    const tooltipClosed = Cookies.get('freemiumTooltip');
    if (tooltipClosed) {
      setShowTooltip(false);
    } else {
      setShowTooltip(true);
    }
  }, []);

  const handleTooltip = () => {
    setShowTooltip(false);

    Cookies.set('freemiumTooltip', 'true', { expires: 7 });
  };

  if (showTooltip === null || isLoading) return null;
  if (!showTooltip || isSubscribed) return null;
  if (themeName !== ECompanyThemeName.DEFAULT) return null;

  return (
    <div
      style={{
        boxShadow: '0 5px 10px rgba(255, 111, 152, 0.3)',
      }}
      className="flex items-center mb-7 flex-wrap text-center relative gap-3 rounded-lg justify-center w-full h-fit py-3 px-12 border-chat-primary border-2 bg-[#FFE2F1]"
    >
      <p className="text-sm font-semibold">{lang.get('msg.freemiumTooltipDescription')}</p>
      <Link
        className="px-4 py-1 text-sm font-semibold text-white rounded-md bg-chat-primary hover:scale-[1.02] transition-all ease-in-out hover:bg-[#ed638a]"
        to={`${Routes.organization.path}/${organization_id}${Routes.choose_your_plan.path}`}
      >
        {lang.get('msg.talkToSales')}
      </Link>
      <button
        type="button"
        onClick={handleTooltip}
        className="absolute -translate-y-1/2 right-4 top-1/2"
      >
        <IconX size={20} />
      </button>
    </div>
  );
}

export default FreemiumTooltip;
